import { render, staticRenderFns } from "./chatHistory.vue?vue&type=template&id=f432790e&scoped=true"
import script from "./chatHistory.vue?vue&type=script&lang=js"
export * from "./chatHistory.vue?vue&type=script&lang=js"
import style0 from "./chatHistory.vue?vue&type=style&index=0&id=f432790e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f432790e",
  null
  
)

export default component.exports